var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_14)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.002 241.252C220.33 241.252 169.753 296.398 169.753 331.207C169.753 346.885 181.797 356.251 201.98 356.251C223.919 356.251 238.407 344.985 256.002 344.985C273.751 344.985 288.278 356.251 310.025 356.251C330.208 356.251 342.251 346.885 342.251 331.207C342.251 296.398 291.674 241.252 256.002 241.252ZM189.842 235.588C185.17 220.022 170.777 209.942 157.696 213.069C144.615 216.195 137.801 231.347 142.472 246.912C147.144 262.478 161.537 272.558 174.618 269.431C187.699 266.305 194.514 251.153 189.842 235.588V235.588ZM227.899 226.253C241.798 222.596 248.752 203.819 243.433 184.314C238.115 164.81 222.536 151.966 208.637 155.623C194.738 159.28 187.785 178.057 193.103 197.562C198.422 217.067 214.005 229.914 227.899 226.253ZM354.304 213.073C341.223 209.947 326.834 220.027 322.158 235.592C317.486 251.157 324.301 266.309 337.382 269.436C350.463 272.562 364.851 262.482 369.528 246.917C374.199 231.352 367.385 216.2 354.304 213.073V213.073ZM284.105 226.253C298.004 229.91 313.582 217.067 318.901 197.562C324.22 178.057 317.266 159.284 303.367 155.623C289.469 151.962 273.89 164.81 268.571 184.314C263.253 203.819 270.206 222.596 284.105 226.253V226.253Z",
    fill: "#B9BECA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.5d90c609b63847b0b9672752bb860006.svg";
export { ForwardRef as ReactComponent };